<template>
  <body>
    <div class="top_bg">
      <div class="left_bg">
        <div class="banner_bg">
          <el-carousel :height="banH + 'px'">
            <el-carousel-item
              v-for="(item, index) in bannerList"
              :key="index"
              height="400px"
            >
              <el-image :src="item.maSaveaddr" style="width:100%;height:100%;">
                <div slot="error">
                  <el-image :src="defaultImg"> </el-image>
                </div>
              </el-image>
            </el-carousel-item>
          </el-carousel>
        </div>

        
        
        <div class="title_bg">
          <el-image :src="iconOne" style="float: left"></el-image>
          <span>新闻动态</span>
          <span @click="toItemPage('newsSta')">查看更多</span>
        </div>
        <el-divider class="line_bg"> </el-divider>
        <ul>
          <li v-for="(item, ad) in newsList" :key="ad" style="list-style: none">
            <div
              class="news_bg"
              @click="checktItemHtml(item.mnContent, item.mnTitle)"
            >
              <el-image :src="item.mnHhimg" class="news_img_bg">
                <div slot="error">
                  <el-image :src="defaultImg"> </el-image>
                </div>
              </el-image>
              <div>
                <p class="title-hover">{{ item.mnTitle }}</p>
                <span>
                  {{ item.mnDigest }}
                </span>
              </div>
            </div>
            <div class="line_two"></div>
          </li>
        </ul>
        <el-image
          :src="regImg"
          class="regist_bg"
          @click="dialogRegistVisible = true"
        ></el-image>
        
        <div class="title_bg">
          <el-image :src="iconTwo" style="float: left"></el-image>
          <span>专家团队</span>
          <span @click="toItemPage('teamExperts')">查看更多</span>
        </div>
        <el-divider class="line_bg"> </el-divider>
        <div class="tiem_bg">
          <div
            v-for="(item, index) in doctorList"
            :key="index"
            style="margin-left: 8px;width:calc(25% - 10px);"
          >
            <!-- @click="checktItemHtml(item, '', 'zjtd')" -->
            <el-image :src="item.etPhoto" class="doctor_bg">
              <div slot="error">
                <el-image :src="defaultImg"> </el-image></div
            ></el-image>
            <p class="title-hover" style="margin:10px 0;">{{ item.etName }}</p>
          </div>
        </div>
      </div>
      <div class="right_bg">
        <div class="title_bg">
          <el-image :src="iconFour" style="float: left"></el-image>
          <span>会议通知</span>
          <span @click="toItemPage('conNotice')">查看更多</span>
        </div>
        <el-divider class="line_bg"> </el-divider>
        <ul class="ul_one">
          <li
            v-for="(item, ad) in noticeList"
            :key="ad"
            @click="checktItemHtml(item.mnContent, item.mnTitle)"
          >
            <p class="title-hover" v-if="item.mnTitle.indexOf('进行中') != -1" style="color:#397b3e;">{{ item.mnTitle }}</p>
            <p class="title-hover" v-else>{{ item.mnTitle }}</p>
            <div class="line_two"></div>
          </li>
        </ul>
        <div>
          <div class="title_bg">
            <el-image :src="iconFive" style="float: left"></el-image>
            <span>图文教学</span>
            <span @click="toItemPage('picStudy')">查看更多</span>
          </div>
          <el-divider class="line_bg"> </el-divider>
          <ul>
            <li
              v-for="(item, ad) in picList"
              :key="ad"
              style="list-style: none"
              @click="checktItemHtml(item.gtContent, item.gtDigest)"
            >
              <el-image :src="item.gtFmimg" class="pic_bg">
                <div slot="error">
                  <el-image :src="defaultImg"> </el-image></div
              ></el-image>
              <p class="font_three title-hover">{{ item.gtTitle }}</p>
              <div class="line_two"></div>
            </li>
          </ul>
        </div>
        <div class="video_bg">
          <div class="title_bg">
            <el-image :src="iconSix" style="float: left"></el-image>
            <span>教学视频</span>
            <span @click="toItemPage('teachVideo')">查看更多</span>
          </div>
          <el-divider class="line_bg"> </el-divider>
          <ul>
            <li
              v-for="(item, ad) in videoList"
              :key="ad"
              style="list-style: none"
              @click="checktItemHtml(item.videoId, item.vtTitle, 'video')"
            >
              <el-image :src="item.vtFmimg" class="pic_bg">
                <div slot="error">
                  <el-image :src="defaultImg"> </el-image></div
              ></el-image>
              <p class="font_three title-hover">{{ item.vtTitle }}</p>
              <div class="line_two"></div>
            </li>
          </ul>
        </div>
        <div>
          <div class="title_bg">
            <el-image :src="iconSeven" style="float: left"></el-image>
            <span>学术文献</span>
            <span @click="toItemPage('scholary')">查看更多</span>
          </div>
          <el-divider class="line_bg"> </el-divider>
          <div
            class="book_bg"
            v-if="acalitList && JSON.stringify(acalitList) != '{}'"
            @click="checktItemHtml(acalitList.atContent, acalitList.atKeyword)"
          >
            <el-image :src="acalitList.atFmimg" class="book_img_bg">
              <div slot="error">
                <el-image :src="defaultImg"> </el-image></div
            ></el-image>
            <div style="width: 235px" class="title-hover">
              <p>{{ acalitList.atTitle }}</p>
              <p>{{ acalitList.atDigest }}</p>
            </div>
          </div>
          <div class="line_two"></div>
        </div>
      </div>
    </div>
    <!-- <div class="bottom_bg">
      <div class="fullSize webLinks">
        <div class="fullCenter" style="text-align: center">
          <div class="content_title">
            <div style="width: 1150px; float: left; text-align: left">
              <img src="../assets/images/index_ico3.png" /><span>友情链接</span>
            </div>
          </div>
          <div style="margin-top: 12px; margin-bottom: 12px">
            <a
              v-for="(item, index) in linkList"
              :key="index"
              @click="checkLinkItem(item)"
            >
              <el-image :src="item.logo" style="width: 230px; height: 80px">
                <div slot="error">
                  <el-image :src="defaultImg"> </el-image></div
              ></el-image>
            </a>
          </div>

          <div>
          </div>
        </div>
      </div>
    </div> -->
            <el-dialog
              :title="htmlTitle"
              :visible.sync="centerDialogVisible"
              width="70%"
              center
            >
              <div class="ql-editor" v-html="htmlInfo"></div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false"
                  >取 消</el-button
                >
                <el-button type="success" @click="centerDialogVisible = false"
                  >确 定</el-button
                >
              </span>
            </el-dialog>

    <div>
      <el-dialog
        title="注册新用户"
        :visible.sync="dialogRegistVisible"
        width="45%"
      >
        <el-form :model="register">
          <el-form-item label="用户名:">
            <el-input
              v-model="register.loginname"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码:">
            <el-input v-model="register.password" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="姓名:">
            <el-input v-model="register.username" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="公司:">
            <el-input
              v-model="register.company"
              autocomplete="off"
            ></el-input> </el-form-item
          ><el-form-item label="科室:">
            <el-input
              v-model="register.deptks"
              autocomplete="off"
            ></el-input> </el-form-item
          ><el-form-item label="专业:">
            <el-input
              v-model="register.speci"
              autocomplete="off"
            ></el-input> </el-form-item
          ><el-form-item label="职称:">
            <el-input
              v-model="register.jobtitle"
              autocomplete="off"
            ></el-input> </el-form-item
          ><el-form-item label="职务:">
            <el-input
              v-model="register.duties"
              autocomplete="off"
            ></el-input> </el-form-item
          ><el-form-item label="电话:">
            <el-input
              v-model="register.phone"
              autocomplete="off"
            ></el-input> </el-form-item
          ><el-form-item label="微信:">
            <el-input
              v-model="register.weixin"
              autocomplete="off"
            ></el-input> </el-form-item
          ><el-form-item label="邮箱:">
            <el-input
              v-model="register.email"
              autocomplete="off"
            ></el-input> </el-form-item
          ><el-form-item label="资格证编码:">
            <el-input v-model="register.ceofel" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="success" @click="addRegister">注 册</el-button>
        </div>
      </el-dialog>
    </div>
  </body>
</template>

<script>
import {
  getBannerList,
  getNewsDetail,
  getaAcalitList,
  getNoticeDetail,
  getGraphicteaching,
  getVideoList,
  getFirstcLink,
  getTeamList,
  register,
} from "@/network/api";

export default {
  name: "HelloWorld",
  data() {
    return {
      banH: 400,
      defaultImg: require("@/assets/images/defalut_icon.png"),
      regImg: require("@/assets/images/index_reg.jpg"),
      iconOne: require("@/assets/images/index_ico1.png"),
      iconTwo: require("@/assets/images/index_ico2.png"),
      iconThree: require("@/assets/images/index_ico3.png"),
      iconFour: require("@/assets/images/index_ico4.png"),
      iconFive: require("@/assets/images/index_ico5.png"),
      iconSix: require("@/assets/images/index_ico6.png"),
      iconSeven: require("@/assets/images/index_ico7.png"),
      iconEight: require("@/assets/images/index_ico3.png"),

      currentDate: new Date(),

      bannerList: [],
      newsList: [],
      acalitList: {},
      noticeList: [],
      picList: [],
      videoList: [],
      linkList: [],
      doctorList: [],

      htmlInfo: "",
      htmlTitle: "",
      centerDialogVisible: false,

      register: {},
      dialogRegistVisible: false,
    };
  },
  mounted() {
    getBannerList().then((res) => {
      console.log(res);
      this.bannerList = res.data;
    });
    let newsParams = {
      pageNum: 1,
      pageSize: 10,
    };
    getNewsDetail(newsParams).then((res) => {
      console.log("getNewsDetail:" + res);
      this.newsList = res.rows;
    });
    let acalitParams = {
      pageNum: 1,
      pageSize: 10,
    };
    getaAcalitList(acalitParams).then((res) => {
      if (res.rows && res.rows.length) {
        this.acalitList = res.rows[0];
      }
    });
    let noticeParams = {
      pageNum: 1,
      pageSize: 10,
      isportal: 'Y'
    };
    getNoticeDetail(noticeParams).then((res) => {
      console.log(":" + res);
      this.noticeList = res.rows;
    });
    let picParams = {
      pageNum: 1,
      pageSize: 10,
    };
    getGraphicteaching(picParams).then((res) => {
      console.log(res);
      this.picList = res.rows;
    });
    let videoParams = {
      pageNum: 1,
      pageSize: 10,
    };
    getVideoList(videoParams).then((res) => {
      this.videoList = res.rows;
    });
    let formData = new FormData();
    formData.append("dpCode", "DP05");
    getFirstcLink(formData).then((res) => {
      if (res.code == 200) {
        this.linkList = res.data;
      }
    });
    getTeamList().then((res) => {
      this.doctorList = res;
    });
  },
  methods: {
    checkLinkItem(item) {
      console.log(item.lkAddr);
      window.open("http://www.baidu.com/", "_blank");
      // window.location.href = "www.baidu.com"
    },
    checktItemHtml(htmlInfo, title, value) {
      // this.centerDialogVisible = true;
      // this.htmlTitle = "";
      // this.htmlInfo = "";
      // this.htmlTitle = title;
      // this.htmlInfo = htmlInfo;
      let p = {};
      if (value == 'video') {
        p = {
          htmlTitle: title,
          videoId: htmlInfo,
          isVideo: true
        }
      } else if (value == 'zjtd') {
        p = {
          obj: htmlInfo,
          isZJTD: true
        }
      } else {
        p = {
          htmlTitle: title,
          htmlInfo: htmlInfo
        }
      }
      this.$router.push({
        name: 'InformationDetail',
        params: p
      })
    },
    toItemPage(path) {
      this.$router.push(path);
      console.log(path);
    },
    addRegister() {
      register(this.register).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "注册成功",
            type: "success",
          });
          this.dialogRegistVisible = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>


<style scoped>
ul,
li {
  margin: 0;
  padding: 0;
}
span {
  margin: 0;
  padding: 0;
}
body {
}
.top_bg {
  display: flex;
  justify-content: center;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.banner_bg {
  width: 750px;
  margin-bottom: 32px;
}
.left_bg {
  width: 750px;
}
.title_bg :nth-child(2) {
  line-height: 38px;
  color: #677eac;
  font-size: 20px;
}
.title_bg :nth-child(3) {
  border: 1px solid #677eac;
  border-radius: 8px;
  padding: 2px 8px 2px 8px;
  font-size: 14px;
  color: #677eac;
  text-decoration: none;
  float: right;
  margin-top: 6px;
}
.title_bg :nth-child(3):hover {
  /* background: #f1f1f1; */
  cursor: pointer;
  border:1px solid #0078ff;
  border-radius:8px;
  padding:2px 8px 2px 8px;
  color:#0078ff;
  text-decoration:none;
}
p {
  margin-bottom: 0px;
  padding-bottom: 0px;
}
.line_bg {
  margin-top: 6px;
  padding: 0;
  margin-bottom: 0px;
  background-color: #7889b0;
}
.news_bg {
  display: flex;
  margin-top: 12px;
}
.news_bg p {
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 5px;
  margin-left: 12px;
}
.news_bg span {
  font-size: 16px;
  color: #909090;
  margin-left: 12px;
}

.line_two {
  border-bottom: 1px dashed #e2e2e2;
  margin-top: 6px;
}
.book_bg {
  display: flex;
  padding-top: 12px;
  padding-bottom: 12px;
}
.title_img {
  display: inline-block;
  vertical-align: middle;
}
.regist_bg {
  margin-top: 20px;
  margin-bottom: 20px;
}
.row_bg {
  margin-top: 12px;
}
.row_bg p {
  text-align: center;
  padding-bottom: 8px;
  font-size: 18px;
}
.tiem_bg {
  margin-bottom: 22px;
  display: flex;
  flex-wrap: wrap;
  margin-top: 12px;
  text-align: center;
}
.right_bg {
  width: 384px;
  margin-left: 20px;
}
.ul_one {
  margin-left: 15px;
  margin-bottom: 24px;
}
.ul_one li {
  margin-top: 10px;
  color: black;
  font-size: 16px;
  font-weight: bold;
}
.font_three {
  text-align: center;
}
.pic_bg {
  width: 340px;
  height: 230px;
  margin-top: 12px;
  padding: 5px 20px 10px;
}
.video_bg {
  margin-top: 24px;
  margin-bottom: 24px;
}
.book_img_bg {
  width: 135px;
  height: 185px;
  margin-right: 12px;
}

.news_img_bg {
  width: 264px;
  height: 174px;
  flex-shrink: 0;
  margin-right: 12px;
}
.doctor_bg {
  width: 180px;
  height: 240px;
}
.bottom_bg {
}
.title-hover:hover {
  cursor: pointer;
  color: #397b3e;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue